import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useLocation } from 'react-router-dom';
import { notify } from '../utils/notifications';
import api from '../api/api';
import '../styles/FeedbackButton.css';

function FeedbackButton() {
    const { user } = useAuth();
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const [category, setCategory] = useState('suggestion');
    const [comment, setComment] = useState('');
    const [submitting, setSubmitting] = useState(false);

    if (!user) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!comment.trim()) {
            notify.warning('Please enter your feedback');
            return;
        }

        setSubmitting(true);
        try {
            await api.post('/user/feedback', {
                category,
                comment: comment.trim(),
                page: location.pathname,
            });
            notify.success('Thanks for your feedback!');
            setOpen(false);
            setComment('');
            setCategory('suggestion');
        } catch (err) {
            notify.error('Failed to submit feedback');
        } finally {
            setSubmitting(false);
        }
    };

    const handleClose = () => {
        if (!submitting) {
            setOpen(false);
        }
    };

    return (
        <>
            <button className="feedback-fab" onClick={() => setOpen(true)}>
                Feedback
            </button>

            {open && (
                <div className="feedback-modal-overlay" onClick={handleClose}>
                    <div className="feedback-modal" onClick={(e) => e.stopPropagation()}>
                        <h2>Send Feedback</h2>
                        <form className="feedback-form" onSubmit={handleSubmit}>
                            <div className="feedback-field">
                                <label htmlFor="feedback-category">Category</label>
                                <select
                                    id="feedback-category"
                                    className="feedback-select"
                                    value={category}
                                    onChange={(e) => setCategory(e.target.value)}
                                >
                                    <option value="suggestion">Suggestion</option>
                                    <option value="bug">Bug Report</option>
                                    <option value="question">Question</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>
                            <div className="feedback-field">
                                <label htmlFor="feedback-comment">Your feedback</label>
                                <textarea
                                    id="feedback-comment"
                                    className="feedback-textarea"
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value)}
                                    placeholder="Tell us what's on your mind..."
                                    maxLength={1000}
                                />
                            </div>
                            <div className="feedback-actions">
                                <button
                                    type="button"
                                    className="feedback-cancel-button"
                                    onClick={handleClose}
                                    disabled={submitting}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="feedback-submit-button"
                                    disabled={submitting || !comment.trim()}
                                >
                                    {submitting ? 'Sending...' : 'Submit'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
}

export default FeedbackButton;
